import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { INVENTORY } from '../../../../constants/inventory'
// services
import { MessageService } from '../../../../services/message.service'
import { MasterService } from '../../../../services/master.service'
import * as languageLibrary from '../../../../services/language'
import { StoreService } from 'src/app/services/store.service';
import moment from 'moment';
import { Vendor } from 'src/app/models/vendor.model';
import { ReconCost } from 'src/app/models/recon-cost.model';
import { ReconDescription } from 'src/app/models/recon-description.model';
import { reconTypeIcon } from 'src/app/utils/icons';
import { formatCurrency } from 'src/app/utils/format';
import { clean } from 'src/app/utils/numeric';
import { minValueValidator } from 'src/app/utils/min-value.validator';
import { formatPhone } from 'src/app/utils/format';
@Component({
    selector: 'inventory-reconditioning-cost',
    templateUrl: './inventory-reconditioning-cost.component.html',
    styleUrls: ['./inventory-reconditioning-cost.component.scss'],
    standalone: false
})
export class InventoryReconditioningCostComponent implements OnInit {
    /*
    * Variables
    */

    // define the inventoryId
    @Input() inventoryId: number = 0

    // save the language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    @Output() emitterInformation$: EventEmitter<Object> = new EventEmitter()

    //  define if some changes not saved
    private savePending: boolean = false

    // set all words
    protected words = languageLibrary.language

    // define expanded
    protected expanded: boolean = true

    // define if is loading
    protected loading: boolean = false

    // form
    protected information = new FormGroup({
        id: new FormControl<number | null>(null),
        phoneNumber: new FormControl<string | null>(null),
        costIncurred: new FormControl<string>(formatCurrency(0), [Validators.required, minValueValidator(1)]),
        dateIncurred: new FormControl<string>(new Date().toISOString().substring(0, 10), [Validators.required]),
        datePaid: new FormControl<string | null>(null),
        checkNumber: new FormControl<string | null>(null),
        referenceNumber: new FormControl<string | null>(null),
        vendorId: new FormControl<number | null>(null),
        type: new FormControl<string | null>(null, [Validators.required]),
        descriptionId: new FormControl<number | null>(null, [Validators.required]),
        inventoryId: new FormControl<number | null>(null, [Validators.required]),
    })

    protected reconCosts: ReconCost[];

    protected reconTypes: string[] = INVENTORY.RECONDITIONING_TYPES

    protected id: number = 0;

    protected selectedId: 0;

    protected descriptions: ReconDescription[] = [];

    protected costIncurred: number;

    protected reconCostTotals: object = {}

    protected reconCostTotal: number = 0;

    private corpId: number;
    
    get groupKeys(): string[] {
        if (!this.reconCostTotals) {
            return []
        }
        
        return Object.keys(this.reconCostTotals)
    }

    constructor(private route: ActivatedRoute, private master: MasterService, private ms: MessageService, private store: StoreService) {
        this.corpId = this.store.userAccount.hasOwnProperty("user") ? this.store.userAccount['user'].corporateId : null
    }

    ngOnInit() {
        this.getReconCostTypes()

        if (this.route.snapshot.params["id"] === 'add') {
            return
        }

        this.getReconCosts()
    }

    ngOnChanges(changes: SimpleChanges): void {
        //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        //Add '${implements OnChanges}' to the class.
        if (changes && changes.inventoryId && changes.inventoryId.currentValue) {
            this.inventoryId = changes.inventoryId.currentValue
        }
    }

    public saveReconCost() {
        const identity = this.information.get('id').value
        if (isNaN(identity) || (identity <= 0)) {
            this.createReconCost()
            return
        }

        this.modifyReconCost(identity)
    }

    public deleteReconCost() {
        if (!this.inventoryId || (this.inventoryId <= 0)) {
            return
        }

        if (!this.id || (this.id <= 0)) {
            return
        }

        this.master.discard(`inventory/${this.inventoryId}/reconCost/${this.id}?sum=${this.costIncurred}`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            (document.getElementById('btn-close-modal-delete-reconCost').click())
            this.reconCosts = res.data.reconditioningCosts
            this.groupReconCosts(res.data.reconditioningCostTotal)
            this.updateReconCostOnGeneralTab(res.data.reconditioningCostTotal['total'] ? res.data.reconditioningCostTotal['total'] : 0.00)
        })
    }

    public modifyReconCost(identity) {
        if (!this.inventoryId || (this.inventoryId <= 0)) {
            return
        }

        if (!identity || (identity <= 0)) {
            return
        }

        this.information.get('inventoryId').setValue(this.inventoryId)
        if (this.information.invalid) {
            return
        }

        const payload = JSON.parse(JSON.stringify(this.information.value))
        payload.costIncurred = clean(payload.costIncurred)

        this.master.put(`inventory/${this.inventoryId}/reconCost/${identity}`, { information: payload }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.reconCosts = res.data.reconditioningCosts
            this.groupReconCosts(res.data.reconditioningCostTotal)
            this.updateReconCostOnGeneralTab(res.data.reconditioningCostTotal['total'] ? res.data.reconditioningCostTotal['total'] : 0.00)
            this.resetInformation()
        })
    }

    public updateReconCostOnGeneralTab(reconCostTotal: number) {
        this.reconCostTotal = reconCostTotal
        this.emitterInformation$.emit({ message: 'setReconCostTotal', reconCostTotal: reconCostTotal })
    }

    private groupReconCosts = (costs) => {
        this.reconCostTotals = {}

        if (!costs || !costs['groupTotals']) {
            return
        }

        const total = parseFloat(costs['total'])

        for (const group of costs['groupTotals']) {
            this.reconCostTotals[group.type] = {
                amount: parseFloat(group.total_amount),
                percent: Math.round((parseFloat(group.total_amount) / total) * 100)
            }
        }
    }

    public createReconCost() {
        if (!this.inventoryId || (this.inventoryId <= 0)) {
            return
        }
        
        this.information.get('inventoryId').setValue(this.inventoryId)
        if (this.information.invalid) {
            return
        }

        const payload = JSON.parse(JSON.stringify(this.information.value))
        payload.costIncurred = clean(payload.costIncurred)

        this.master.post(`inventory/${this.inventoryId}/reconCost`, { information: payload }, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.reconCosts = res.data.reconditioningCosts
            this.groupReconCosts(res.data.reconditioningCostTotal)
            this.updateReconCostOnGeneralTab(res.data.reconditioningCostTotal['total'] ? res.data.reconditioningCostTotal['total'] : 0.00)
            this.resetInformation()
        })
    }

    public getReconCosts() {
        if (!this.inventoryId || (this.inventoryId <= 0)) {
            return
        }

        this.master.get(`inventory/${this.inventoryId}/reconCosts`, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.reconCosts = res.data.reconditioningCosts
            this.groupReconCosts(res.data.reconditioningCostTotal)
            this.updateReconCostOnGeneralTab(res.data.reconditioningCostTotal['total'] ? res.data.reconditioningCostTotal['total'] : 0.00)
        })
    }


    public getReconCostTypes() {
        if (!this.corpId || (this.corpId <= 0)) {
            return
        }

        this.master.get(`corporations/${this.corpId}/reconDesc`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.descriptions = res.data.reconDescriptions
        })
    }

    public resetInformation() {
        this.information.reset();
        this.information.get('dateIncurred').setValue(moment().format('YYYY-MM-DD'));
        document.getElementById('btn-save').innerHTML = 'Save'
        this.selectedId = null
    }

    public setId(e: Event, id: number, cost: number) {
        this.id = id
        this.costIncurred = cost
    }

    public setInformation(reconditioningCosts: any) {
        (document.getElementById('btn-save').innerHTML = 'Update')
        this.selectedId = reconditioningCosts.id

        this.information.setValue({
            id: reconditioningCosts.id,
            phoneNumber: reconditioningCosts.phoneNumber,
            costIncurred: formatCurrency(reconditioningCosts.costIncurred),
            dateIncurred: reconditioningCosts.dateIncurred,
            datePaid: reconditioningCosts.datePaid,
            checkNumber: reconditioningCosts.checkNumber,
            referenceNumber: reconditioningCosts.referenceNumber,
            vendorId: reconditioningCosts.vendorId,
            type: reconditioningCosts.type,
            descriptionId: reconditioningCosts.descriptionId,
            inventoryId: reconditioningCosts.inventoryId,
        })
    }

    /**
     * 
     * @param contactId 
     */
    public setContactIdEvent(contactId: number) {
        if (!contactId) {
            this.information.get("vendorId").reset()
            return
        }

        this.information.get("vendorId").setValue(contactId)

        // Read communincations to try and get a phone number
        this.master.get(`contacts/${contactId}/communications`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            const comms = res.data.communications
            if (!comms || (comms.length <= 0)) {
                return
            }

            const phone = comms.find((comm) => (comm.primary && comm.type === 'phone'))
            if (!phone) {
                return
            }

            this.information.get("phoneNumber").setValue(phone.value)
        })
    }

    /**
     * Given a recon type produce a material icon
     * @param type The recon type to map to an icon name.
     * @returns The material deesign icon name
     */
    protected iconify = (type: string): string => {
        return reconTypeIcon(type)
    }

    /**
     * 
     * @param digits 
     * @returns 
     */
    protected formatPhone = (digits: string) => {
        if (!digits) {
            return 'no phone'
        }

        return formatPhone(digits.replace(/[^0-9]/, ''))
    }
}
